import gqlClient from '../gql';
import { GET_BREAKING_NEWS, breakingNewsVariables } from '../graphql';
import {
  BreakingNew,
  BreakingNewResponse,
  BreakingNewsWithThreads,
  BreakingNewsRecord,
  Channel,
} from '../model';
import { gql } from '@apollo/client';
import { setBreakingNewsRecords } from '../helper/setBreakingNewsRecords';

export const getBreakingNews = async (
  channel: Channel,
): Promise<BreakingNew[] | undefined> => {
  try {
    // @ts-ignore
    const breakingNewResponse = await gqlClient.query<BreakingNewResponse>({
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
      query: GET_BREAKING_NEWS,
      variables: breakingNewsVariables(channel.id),
    });

    const allNews: BreakingNew[] = [];

    const breakingNews = breakingNewResponse?.data?.BreakingNews.docs;
    await setBreakingNewsRecords(channel, breakingNews);
    (breakingNews as unknown as Array<BreakingNewsWithThreads>).forEach(
      news => {
        if (news && !news.timestamp && news.updatedAt) {
          news.timestamp = news.updatedAt;
        }
        allNews.push(news);
        if (news.threads && news.threads.length > 0) {
          news.threads.forEach((thread, index) => {
            allNews.push({
              id: thread.id,
              title: thread.title,
              description: thread.description,
              twitterId: thread.twitterId,
              timestamp: thread.timestamp as string,
              updatedAt: thread.timestamp as string,
              status: news.status,
              isPinned: index < 3 && news.isPinned,
            });
          });
        }
      },
    );

    return allNews;
  } catch (error) {
    console.error('Error getting breaking news:', error);
  }
};

type MultiBreakingNewsRecord = Record<string, { docs: BreakingNewsRecord[] }>;

export const getBreakingNewsRecords = async ({
  dynamicQuery,
  dynamicVariables,
}: {
  dynamicQuery: string;
  dynamicVariables: any;
}): Promise<MultiBreakingNewsRecord | undefined> => {
  try {
    const liveCoverageResponse = await gqlClient.query<MultiBreakingNewsRecord>(
      {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        query: gql`
          ${dynamicQuery}
        `,
        variables: dynamicVariables,
      },
    );

    return liveCoverageResponse?.data;
  } catch (error) {
    console.error('Error getting breaking news records:', error);
  }
};
